/* eslint-disable camelcase */
import React, { useState, useEffect } from "react"
import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import {
  Box,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Tooltip,
  Checkbox,
  FormControlLabel,
} from "@mui/material"
import Swal from "sweetalert2"
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import BackIcon from "../../../components/BackIcon"
import GrabarIcon from "../../../assets/iconos/Grabar.ico"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import CustomBackdrop from "../../../components/CustomBackdrop"
import ImprimirIcon from "../../../assets/iconos/Impresion.ico"
import DetalleImpresion from "../../Zonas/components/DetalleImpresion"
import MotivosPdf from "../components/MotivosPdf"
const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))
const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})
const EditarMotivo = () => {
  const { id } = useParams()
  const location = useLocation()
  const datoSeleccionado = location.state
  const estadoActual = datoSeleccionado.motstatus
  const descripcionActual = datoSeleccionado.motdescripcion
  const tipoActual = datoSeleccionado.mottipo

  const [openModal, setOpenModal] = useState(false)
  const [infoGenerada, setInfoGenerada] = useState([])
  const handleOpenModal = () => {
    const datos = getDatosActuales()
    console.log("datos", datos)
    setInfoGenerada(datos) // Asigna los datos de la tabla al estado
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
    navigate(`/home/dashboard/Motivos`)
  }
  function getDatosActuales() {
    return [
      {
        motcodigo: id,
        motdescripcion: descripcionActual,
        motstatus: estadoActual,
        mottipo: tipoActual,
      },
    ]
  }
  const navigate = useNavigate()

  // Valores por defectos para los comboboxes y el check
  const Estados = [
    { value: "A", description: "ACTIVO" },
    { value: "I", description: "INACTIVO" },
  ]
  const Tipos = [
    { value: "SOLING", description: "INGRESO" },
    { value: "SOLEGR", description: "EGRESO" },
  ]
  const findEstado = (estadoCurrent) => {
    const result = Estados.find((estado) => estado.value === estadoCurrent)
    return result
  }
  const findTipo = (tipoCurrent) => {
    const result = Tipos.find((tipo) => tipo.value === tipoCurrent)
    return result
  }
  // Estados para manejaar el formulario de opciones
  // cuando llame a las funciones set, se actualizara el valor de los otros campos y se re renderiza
  const [codigo, setCodigo] = useState(id)
  const [descripcion, setDescripcion] = useState(descripcionActual)
  const [estado, setEstado] = useState(findEstado(estadoActual))
  const [tipo, setTipo] = useState(findTipo(tipoActual))
  const { mutateAsync: updateMotivo, isPending: isUpdatingMotivo } = useUpdateMotivo()

  function useUpdateMotivo() {
    const queryClient = useQueryClient()
    return useMutation({
      mutationFn: async (motivo) => {
        // send api update request here
        // send api update request here
        const options = {
          method: "PUT",
          body: JSON.stringify(motivo),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("json", options.body)
        let response = await fetchwrapper(`/Motivos/updateMotivo/${id}`, options)

        response = response.json()
        console.log(response)
        return response
      },
      // client side optimistic update
      onMutate: (newMotivo) => {
        console.log(newMotivo, "onmutate")
        queryClient.setQueryData(["Motivo", id], (prevMotivo) => ({
          ...newMotivo,
        }))
      },
      // onSettled: () => queryClient.invalidateQueries({ queryKey: ['bancoDePreguntas'] }), //refetch bancoDePreguntas after mutation, disabled for demo
    })
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const motivo = {
        descripcionMotivo: descripcion,
        estadoMotivo: estado.value,
        tipoMotivo: tipo.value,
      }
      console.log("json", motivo)
      await updateMotivo(motivo)
      Swal.fire({
        icon: "success",
        title: "Operación exitosa",
        text: "Se pudo editar el motivo",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/home/dashboard/Motivos") // Navegar a la ruta especificada
        }
      })
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "No se pudo editar el motivo",
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/home/dashboard/Motivos") // Navega de vuelta cuando se cierre el SweetAlert
      })
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Motivos de Solicitud</b>
        </div>
        <Box className={StyledRoot}>
          <form onSubmit={handleSubmit}>
            <Tooltip title="Grabar">
              <Button type="submit" color="primary" sx={{ marginTop: "15px" }}>
                <img src={GrabarIcon} alt="Grabar" style={{ width: "40px" }} />
              </Button>
            </Tooltip>
            <Tooltip title="Imprimir">
              <Button color="primary" onClick={handleOpenModal} sx={{ marginTop: "15px" }}>
                <img src={ImprimirIcon} alt="Imprimir" style={{ width: "30px" }} />
              </Button>
            </Tooltip>
            <DetalleImpresion
              open={openModal}
              handleClose={handleCloseModal}
              infoGenerada={getDatosActuales()}
              nombrePdf={"Motivo"}
              PdfComponent={MotivosPdf}
            />
            <TextField
              label="Código"
              margin="normal"
              fullWidth
              value={codigo}
              required
              disabled
              onChange={(e) => setCodigo(e.target.value)}
              inputProps={{ maxLength: 3 }}
            />
            <TextField
              label="Descripción"
              margin="normal"
              fullWidth
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              required
            />
            <div>
              <InputLabel id="estadoMotivosCB" sx={{ paddingBlock: "15px", paddingLeft: "5px" }}>
                Estado del motivo
              </InputLabel>
              <Select
                fullWidth
                labelId="estadoMotivosCB"
                value={estado.value}
                onChange={(e) => {
                  const selectedValue = e.target.value
                  const motivoestado = Estados.find((estado) => estado.value === selectedValue)
                  setEstado(motivoestado)
                  //   clearAll(tipoPregunta)
                }}
              >
                {Estados.map((estado) => (
                  <MenuItem key={estado.value} value={estado.value}>
                    {estado.description}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div>
              <InputLabel id="tipoMotivosCB" sx={{ paddingBlock: "15px", paddingLeft: "5px" }}>
                Tipo del motivo
              </InputLabel>
              <Select
                fullWidth
                labelId="tipoMotivosCB"
                value={tipo.value}
                onChange={(e) => {
                  const selectedValue = e.target.value
                  const motivotipo = Tipos.find((tipo) => tipo.value === selectedValue)
                  setTipo(motivotipo)
                  //   clearAll(tipoPregunta)
                }}
              >
                {Tipos.map((tipo) => (
                  <MenuItem key={tipo.value} value={tipo.value}>
                    {tipo.description}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </form>
        </Box>
        <CustomBackdrop isLoading={isUpdatingMotivo} />
      </div>
    </ThemeProvider>
  )
}

export default EditarMotivo
